module.exports = __webpack_public_path__ + "media/honey_roshan.59960f5b.webm";